export interface PlanCuenta {
  idPlanCuenta: number;
  codigoCuenta: string;
  descripcion: string;
  nivel: number;
  codigoCuentaPadre: string | null;
  idPlanCuentaPadre: number | null;
  naturalezaCuenta: string;
  tipoCuenta: string;
  monedaControl: string | null;
  esMovimiento: boolean;
  esEstadoFinanciero: boolean;
  activo: boolean;
  cuentasHijas?: PlanCuenta[];
}

export const NATURALEZA_OPTIONS = [
  { value: 'D', label: 'Deudora' },
  { value: 'H', label: 'Acreedora' },
];

export const TIPO_CUENTA_OPTIONS = [
  { value: 'B', label: 'Balance' },
  { value: 'R', label: 'Resultado' },
];

export const initialPlanCuenta: Partial<PlanCuenta> = {
  idPlanCuenta: 0,
  codigoCuenta: '',
  descripcion: '',
  nivel: 1,
  codigoCuentaPadre: null,
  idPlanCuentaPadre: null,
  naturalezaCuenta: 'D',
  tipoCuenta: 'B',
  monedaControl: null,
  esMovimiento: false,
  esEstadoFinanciero: false,
  activo: true,
};
